<template>
  <div>
    <sidebar></sidebar>
    <navbar :pageIndex="pageIndex"></navbar>
    <div class="photos">
      <img src="@/assets/image/contactus.jpg" alt="">
    </div>
    <div class="contact-container">
      <div class="us-info">
        <div class="info-box">
          <div class="el-icon-phone-outline info-logo"></div>
          <div class="info-con">
            <div>联系电话</div>
            <p>{{companyInfo.phone}}</p>
          </div>
        </div>
        <div class="info-box">
          <div class="el-icon-message info-logo"></div>
          <div class="info-con">
            <div>电子邮箱</div>
            <p>{{companyInfo.mail}}</p>
          </div>
        </div>
        <div class="info-box">
          <div class="el-icon-location-outline info-logo"></div>
          <div class="info-con">
            <div>公司地址</div>
            <p>{{companyInfo.address}}</p>
          </div>
        </div>
      </div>
      <div class="us-map">
        <baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler">
          <!--缩放-->
          <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
          <!--定位 :showAddressBar="true"-->
          <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :autoLocation="true"></bm-geolocation>
          <!--点-->
          <bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP"></bm-marker>
        </baidu-map>
      </div>
      <div class="form-title">
        <div>请填写右侧信息</div>
        <div>便于我们了解您的需求</div>
        <p>收到您的消息后，我们会尽快联系您</p>
        <div class="l-l"></div>
      </div>
      <div class="info-form">
        <el-form ref="form" :model="form" :show-message="false" label-width="80px">
          <div class="form-top">
            <div class="form-box">
              <el-form-item style="margin-bottom: 8px"
                            prop="name"
                            :rules="[{required:true}]">
                <el-input v-model="form.name" placeholder="姓名（必填）"></el-input>
              </el-form-item>
            </div>
            <div class="form-box">
              <el-form-item style="margin-bottom: 8px"
                            prop="phone"
                            :rules="[{required:true,pattern:/^1[34578]\d{9}$/,
                        trigger: ['blur', 'change']}]">
                <el-input v-model="form.phone" placeholder="电话（必填）"></el-input>
              </el-form-item>
            </div>
            <div class="form-box">
              <el-form-item>
                <el-input v-model="form.wechat" placeholder="微信"></el-input>
              </el-form-item>
            </div>
            <div class="form-box">
              <el-form-item style="margin-bottom: 8px"
                            prop="mail"
                            :rules="[{ required:true}]">
                <el-input v-model="form.mail" placeholder="邮箱（必填）"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-bot">
            <div style="width: 435px">
              <el-form-item style="margin-bottom: 8px"
                            prop="mark"
                            :rules="[{required:true}]">
                <el-input type="textarea" v-model="form.mark" placeholder="留言（必填）"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item>
            <div class="submit-btn" @click="onSubmit(form)">提交信息</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
  import navbar from "../../components/navbar";
  import myFooter from "../../components/myFooter";
  import sidebar from "../../components/sidebar";

  export default {
    name: "index",
    components: {
      navbar,myFooter,sidebar
    },
    created() {
      this.$http.get('/api/company/info/list').then((res) => {
        this.companyInfo = res.data.rows[0]
        console.log('1',this.companyInfo)
        this.map.center={lng: this.companyInfo.longitude, lat: this.companyInfo.latitude}
      })
    },
    mounted() {
    },
    data() {
      return {
        pageIndex:5,
        form: {
          name: '',
          phone: '',
          wechat: '',
          mail: '',
          mark: ''
        },
        companyInfo:{},
        map: {
          center: {lng: 1, lat: 1},
          zoom: 15,
          show: true,
          dragging: true
        },
      }
    },
    methods: {
      handler({map}) {
        map.enableScrollWheelZoom(true);
      },
      onSubmit(form) {
        //提交表单
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$http.post('/api/leaveWord/info', this.form).then((res) => {
              console.log(res)
              if (res.data.code === 200) {
                this.$message('提交成功')
                // this.open()
                console.log(res.data.msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  }
</script>

<style scoped>
  .map {
    min-width: 450px;
    height: 100%;
  }
  .photos {
    width: 100%;
    height: 0;
    padding-bottom: 18.7%;
  }
  .photos img{
    width: 100%;
  }
  .contact-container {
    width: 60%;
    margin: 0 auto;
    padding-top: 80px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .us-info {
    width: 40%;
    height: 290px;
    border-bottom: 1px solid #eee;
  }

  .info-box {
    display: flex;
    align-items: center;
    height: 25%;
  }

  .info-logo {
    height: 80px;
    font-size: 36px;
    line-height: 80px;
    margin-right: 20px;
    color: #333;
  }

  .info-con div {
    font-weight: bold;
    margin-bottom: 5px;
    font-size: 14px;
  }

  .info-con p {
    font-size: 12px;
    color: #666;
  }

  .us-map {
    width: 60%;
    height: 290px;
    border-bottom: 1px solid #eee;
    padding: 0 40px 20px 0;
    box-sizing: border-box;
  }

  .form-title {
    margin-top: 60px;
    font-weight: bold;
    height: 300px;
    position: relative;
    width: 40%;
  }

  .form-title p {
    font-weight: 500;
    font-size: 12px;
    color: #666;
    margin-top: 20px;
  }

  .info-form {
    width: 60%;
    padding-top: 40px;
  }

  .form-top {
    display: flex;
    width: 600px;
    flex-wrap: wrap;
  }

  .form-box {
    width: 240px;
    display: flex;
    height: 40px;
    margin-top: 20px;
  }

  .form-box span {
    color: red;
  }

  .el-form-item {
    margin-left: -70px;
  }

  .form-bot {
    width: 450px;
    margin-top: 20px;
    display: flex;
  }

  .l-l {
    width: 20px;
    border: 1px solid #000;
    position: absolute;
    bottom: 80px;
    left: 0;
  }

  .submit-btn {
    width: 80px;
    height: 30px;
    font-weight: bold;
    font-size: 12px;
    border: 1px solid #eee;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }

  .submit-btn:hover {
    border: 1px solid #333;
  }

</style>



// WEBPACK FOOTER //
// src/pages/contact/index.vue